import styled from '@emotion/styled';

const HeaderContentWrapper = styled('section')({
  paddingLeft: 16,
  display: 'flex',
  alignItems: 'center',
});

export default HeaderContentWrapper;
